export default __webpack_public_path__ + "static/media/sleek-and-user-friendly.ff0298c8.svg";